// extracted by mini-css-extract-plugin
var _1 = "ra-cms-module-testimonials-reviews-author";
var _2 = "ra-cms-module-testimonials-reviews-details";
var _3 = "ra-cms-module-testimonials-reviews-footer";
var _4 = "ra-cms-module-testimonials-reviews-logo";
var _5 = "ra-cms-module-testimonials-reviews-score";
var _6 = "ra-cms-module-testimonials-author";
var _7 = "ra-cms-module-testimonials";
var _8 = "ra-cms-module-testimonials-container";
var _9 = "ra-cms-module-testimonials-details";
var _a = "ra-cms-module-testimonials-item";
var _b = "ra-cms-module-testimonials-item-large";
var _c = "ra-cms-module-testimonials-link";
var _d = "ra-cms-module-testimonials-quote";
var _e = "ra-cms-module-testimonials-score";
var _f = "ra-cms-module-testimonials-default";
var _10 = "ra-cms-module-testimonials-home";
var _11 = "ra-cms-module-testimonials-simple";
export { _1 as "cmsModuleTestimonialReviewsAuthorCls", _2 as "cmsModuleTestimonialReviewsDetailsCls", _3 as "cmsModuleTestimonialReviewsFooterCls", _4 as "cmsModuleTestimonialReviewsLogoCls", _5 as "cmsModuleTestimonialReviewsScoreCls", _6 as "cmsModuleTestimonialsAuthorCls", _7 as "cmsModuleTestimonialsCls", _8 as "cmsModuleTestimonialsContainerCls", _9 as "cmsModuleTestimonialsDetailsCls", _a as "cmsModuleTestimonialsItemCls", _b as "cmsModuleTestimonialsItemLargeCls", _c as "cmsModuleTestimonialsLinkCls", _d as "cmsModuleTestimonialsQuoteCls", _e as "cmsModuleTestimonialsScoreCls", _f as "cmsModuleTestimonialsTypeDefaultCls", _10 as "cmsModuleTestimonialsTypeHomeCls", _11 as "cmsModuleTestimonialsTypeSimpleCls" }
